import { render, staticRenderFns } from "./ImportInvestorIncomeDialog.vue?vue&type=template&id=1592222c&scoped=true&lang=pug&"
import script from "./ImportInvestorIncomeDialog.vue?vue&type=script&lang=ts&"
export * from "./ImportInvestorIncomeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ImportInvestorIncomeDialog.vue?vue&type=style&index=0&id=1592222c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1592222c",
  null
  
)

export default component.exports